@if (childProperty1 >= 1) {
  <ion-card class="lucky-slider"  (click)="showJackpotExpandView($event)">
    <ion-icon name="information-circle-outline" class="i-info" (click)="opentriggerInfo($event)">
    </ion-icon>
    <div class="trigger-mini-card">
      <img [src]="syndicateData?.jackpot_triggers?.icon_url" class="fit-jack-image" alt="Jackpot trigger widget icon" />
    </div>
    <div class="trigger-mini-title">
      <h5>{{ syndicateData?.jackpot_triggers?.title }}</h5>
    </div>
    <div class="trigger-mini-subtitle">
      <h6>{{JackpotpotTriggerActiveCount()}} {{'Syndicatepage.active' | translate}}</h6>
    </div>
  </ion-card>
}
